import { Field, useFormikContext } from 'formik';
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { NumberOfEmployees } from '../../../shared/Constants';
import { getNumberOfEmployeesLabel } from '../../../utils/AppUtil';
import { DropdownWithValidation } from '../../../components/prime-formik';

const messages = defineMessages({
  numberOfInternalRespondents: {
    id: 'accounts.add-client.number-of-internal-respondents',
    defaultMessage: 'Number of Internal Respondents',
  },
  selectedByClient: {
    id: 'accounts.add-client.selected-by-client',
    defaultMessage: 'Selected by client',
  },
});

const NumberOfEmployeesInput = ({ availableNumbersOfEmployees }) => {
  const { formatMessage } = useIntl();
  const { setFieldValue } = useFormikContext();

  const buildNumberOfEmployeesOptions = () => {
    const numberOfEmployeesOptions = [];
    numberOfEmployeesOptions.push({
      value: NumberOfEmployees.SELECTED_BY_CLIENT,
      label: formatMessage(messages.selectedByClient),
    });

    availableNumbersOfEmployees.forEach((numberOfEmployees) => {
      const option = {
        value: numberOfEmployees,
        label: getNumberOfEmployeesLabel(numberOfEmployees),
      };

      numberOfEmployeesOptions.push(option);
    });

    return numberOfEmployeesOptions;
  };

  return (
    <div className="p-col-12">
      <label
        htmlFor="numberOfEmployees"
        style={{
          marginRight: '0.25rem',
        }}
      >
        {formatMessage(messages.numberOfInternalRespondents)}
      </label>
      <i
        className="fas fa-question-circle"
        title="As point of basis, the number of Internal Respondents should not supersede the number of employees and other long-term relations in your organisation. The retention fee increases with the number of Internal Respondent"
      />
      <Field
        id="numberOfEmployees"
        name="numberOfEmployees"
        labelText={formatMessage(messages.numberOfInternalRespondents)}
        component={DropdownWithValidation}
        options={buildNumberOfEmployeesOptions()}
        onChange={(e) => {
          setFieldValue('numberOfEmployees', e.target.value);
        }}
      />
    </div>
  );
};

export default NumberOfEmployeesInput;
